import { create } from 'zustand';
import { ToastItem } from '../components/feedback/ToastContainer';

interface UIState {
  isLoading: boolean;
  toasts: ToastItem[];
  setLoading: (loading: boolean) => void;
  showToast: (type: ToastItem['type'], message: string, duration?: number) => void;
  addToast: (toast: Omit<ToastItem, 'id'> | ToastItem) => void;
  removeToast: (id: string) => void;
  clearToasts: () => void;
  showLoading: () => void;
  hideLoading: () => void;
}

export const useUIStore = create<UIState>((set) => ({
  isLoading: false,
  toasts: [],
  
  setLoading: (loading) => set({ isLoading: loading }),
  
  showToast: (type, message, duration = 3000) => set((state) => ({
    toasts: [
      ...state.toasts,
      {
        id: Date.now().toString(),
        type,
        message,
        duration,
      },
    ],
  })),
  
  addToast: (toast) => set((state) => ({
    toasts: [
      ...state.toasts,
      {
        id: 'id' in toast ? toast.id : Date.now().toString(),
        ...toast,
      },
    ],
  })),
  
  showLoading: () => set({ isLoading: true }),
  hideLoading: () => set({ isLoading: false }),
  
  removeToast: (id) => set((state) => ({
    toasts: state.toasts.filter((toast) => toast.id !== id),
  })),
  
  clearToasts: () => set({ toasts: [] }),
}));